import {map, merge} from 'rxjs';

import {Conversation} from '@stripe-internal/conversations-client';
import {useSyncConversationObservable} from '@stripe-internal/conversations-ui';

export function useConversationEnded(conversation: Conversation) {
  return useSyncConversationObservable({
    observable: () =>
      merge(
        conversation.statusObservable(),
        conversation.participantsObservable(),
      ).pipe(map(() => conversation.hasEnded)),
    get: () => conversation.hasEnded,
  });
}
